import styled from 'styled-components';
import { device } from 'constants/index';
import Lottie from 'react-lottie';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 145px;
  flex-direction: row;
  width: 100%;
  margin-bottom: 100px;
  @media ${device.md} {
    flex-direction: column;
    gap: 0;
    justify-content: start;
    padding: 30px;
    height: 100%;
  }
`;

const Loader = styled(Lottie)`
  width: 400px;
  @media ${device.md} {
    max-width: 80%;
  }
`

const Description = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 32px;
  max-width: 455px;
  @media ${device.md} {
    gap: 30px;
    align-items: center;
    max-width: none;
    width: 100%;
  }
`
const LoadingStep = styled.label`
  color: #1C1C1C;
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 48px;
  @media ${device.md} {
    font-size: 30px;
    line-height: 40px;
  }
`


const LoadingDescription = styled.p`
  color: #5F5F63;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  font-family: "Dexa Pro";
  font-weight: 400;
  @media ${device.md} {
    text-align: center;
  }
`


export { 
  Wrapper,
  Loader,
  Description,
  LoadingStep,
  LoadingDescription
};
